import { render, staticRenderFns } from "./system-settings.vue?vue&type=template&id=6a6b6ec5"
import script from "./system-settings.vue?vue&type=script&lang=js"
export * from "./system-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports